import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';

import App from './pages';

import { store } from './modules/stores';
import * as serviceWorker from './serviceWorker';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as types from 'styled-components/cssprop';

import './index.css';
import './components/index.css';
import '@treelab/panda/build/dist/index.css';
import './panda/panda/styles';

const queryString = window.location.search;
const rawUrlParams = new URLSearchParams(queryString);
const urlParams = {
  workspaceId: rawUrlParams.get('workspaceId'),
  coreId: rawUrlParams.get('coreId'),
  tableId: rawUrlParams.get('tableId'),
  viewId: rawUrlParams.get('viewId'),
  blockId: rawUrlParams.get('blockId'),
  locale: rawUrlParams.get('locale'),
  isExpand: rawUrlParams.get('isExpand'),
  meId: rawUrlParams.get('meId'),
  sessionId: rawUrlParams.get('sessionId'),
  hasPermission: rawUrlParams.get('hasPermission'),
  index: Number(rawUrlParams.get('index')) || 0,
};

ReactDOM.render(
  <ReduxProvider store={store as any}>
    <App urlParams={urlParams} />
  </ReduxProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
